var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _polygon, _rect, _polygon2, _g2, _g3, _g4, _path11, _path12, _polygon3, _polygon4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _path13, _path14, _path15, _path16, _path17, _path18, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialLife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #674748;\n      }\n\n      .cls-2 {\n        fill: #65a0b4;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #b5706f;\n      }\n\n      .cls-5 {\n        fill: #99645f;\n      }\n\n      .cls-6 {\n        fill: #afd080;\n      }\n\n      .cls-7 {\n        fill: #c6e2e3;\n      }\n\n      .cls-8 {\n        fill: #ddeee9;\n      }\n\n      .cls-9 {\n        fill: #de7e68;\n      }\n\n      .cls-10 {\n        fill: #43a95f;\n      }\n\n      .cls-11 {\n        fill: #a2d5da;\n      }\n\n      .cls-12 {\n        fill: #94c25e;\n      }\n\n      .cls-13 {\n        fill: #576481;\n      }\n\n      .cls-14 {\n        fill: #71b763;\n      }\n\n      .cls-15 {\n        opacity: .6;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 128,
    cy: 128,
    r: 90
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M38.06,125.68c-.02,.77-.06,1.54-.06,2.32,0,6.98,.82,13.77,2.33,20.3,16.79,10.49,54.75,17.81,98.92,17.81,28.42,0,54.27-3.03,73.57-7.99,3.34-9.42,5.18-19.55,5.18-30.12,0-4.24-.32-8.41-.88-12.5-21.98-10.73-47.28-15.08-77.87-15.08-46.28,0-85.76,13.96-101.19,25.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M38.55,134.87c-.02,.73-.05,1.45-.06,2.18,.39,3.82,.99,7.58,1.84,11.25,16.79,10.49,54.75,17.81,98.92,17.81,28.42,0,54.27-3.03,73.57-7.99,3.34-9.42,5.18-19.55,5.18-30.12,0-2.14-.08-4.25-.23-6.35-21.05-7.44-36.78-10.14-63.64-7.99-49.61,3.97-98.99,9.92-115.58,21.21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53.6,122.19c-4.02,1.05-10.22,3.11-15.58,4.96,0,.28-.02,.56-.02,.85,0,12.9,2.74,25.16,7.63,36.26,9,.81,20.98,1.85,22.8,1.85,2.96,0,25.32-27.86,25.32-27.86-16.49-1.54-31.79-18.23-40.14-16.05Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M217.92,131.34c-12.4-5.9-22.55-12.91-29.71-12.05-9.04,1.09-38.43,13.98-38.43,13.98l39.19,25.42h23.66c3.11-8.58,4.94-17.78,5.29-27.35Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M212.76,141.02c0-4.89-3.9-23.95-6.37-23.95s-6.37,19.06-6.37,23.95c0,4.37,2.28,6.78,5.27,7.24v5.99c0,.6,.49,1.09,1.1,1.09s1.1-.49,1.1-1.09v-5.99c2.99-.47,5.27-2.88,5.27-7.24Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M202,143.28c0-3.41-2.73-16.73-4.45-16.73s-4.45,13.32-4.45,16.73c0,3.05,1.59,4.73,3.68,5.06v4.19c0,.42,.34,.76,.76,.76s.76-.34,.76-.76v-4.19c2.09-.33,3.68-2.01,3.68-5.06Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M72.87,146.67c0-3.41-2.73-16.73-4.45-16.73s-4.45,13.32-4.45,16.73c0,3.05,1.59,4.73,3.68,5.06v4.19c0,.42,.34,.76,.77,.76s.77-.34,.77-.76v-4.19c2.09-.33,3.68-2.01,3.68-5.06Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M61.99,145.83c0-2.56-2.05-12.56-3.34-12.56s-3.34,10-3.34,12.56c0,2.29,1.2,3.55,2.77,3.8v3.14c0,.32,.26,.57,.57,.57s.57-.26,.57-.57v-3.14c1.57-.25,2.77-1.51,2.77-3.8Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M53.6,145.9c0-3.26-2.6-15.97-4.25-15.97s-4.25,12.71-4.25,15.97c0,2.91,1.52,4.52,3.52,4.83v4c0,.4,.33,.73,.73,.73s.73-.33,.73-.73v-4c2-.31,3.52-1.92,3.52-4.83Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.54,161.87c-1.6,0-2.9-1.3-2.9-2.9v-45.48c0-1.6,1.3-2.9,2.9-2.9s2.9,1.3,2.9,2.9v45.48c0,1.6-1.3,2.9-2.9,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M114.86,123.81c1.33-1.91,2.12-4.23,2.12-6.74,0-5.29-3.49-9.72-8.28-11.24-.04-.03-.08-.08-.12-.11,.43-1.21,.7-2.49,.7-3.85,0-6.41-5.2-11.61-11.61-11.61-.93,0-1.82,.14-2.69,.34-2.63-3.71-6.94-6.15-11.83-6.15-8.02,0-14.52,6.5-14.52,14.52,0,1.68,.34,3.28,.87,4.78-5.68,2.87-9.58,8.74-9.58,15.54,0,9.59,7.75,17.37,17.33,17.42,2.45,2.24,5.68,3.63,9.26,3.63,2.66,0,5.12-.79,7.23-2.09,1.08,.2,2.19,.32,3.33,.32,2.2,0,4.3-.41,6.25-1.13,5.68,.79,11.4,1.45,11.76,.97,.29-.38-.36-5.33-1.24-11.13,.45-1.1,.79-2.26,1.01-3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M114.86,123.81c1.33-1.91,2.12-4.23,2.12-6.74,0-5.29-3.49-9.72-8.28-11.24-.04-.03-.08-.08-.12-.11,.43-1.21,.7-2.49,.7-3.85,0-6.41-5.2-11.61-11.61-11.61-.93,0-1.82,.14-2.69,.34-2.63-3.71-6.94-6.15-11.83-6.15-3.76,0-7.16,1.47-9.74,3.82,1.2-.32,2.44-.55,3.75-.55,4.89,0,9.2,2.44,11.83,6.15,.87-.21,1.76-.34,2.69-.34,6.41,0,11.61,5.2,11.61,11.61,0,1.36-.28,2.64-.7,3.85,.04,.03,.08,.08,.12,.11,4.79,1.52,8.28,5.94,8.28,11.24,0,2.51-.79,4.82-2.12,6.74-.23,1.2-.57,2.36-1.01,3.46,.44,2.91,.82,5.6,1.06,7.62,3.35,.38,5.93,.57,6.17,.25,.29-.38-.36-5.33-1.24-11.13,.45-1.1,.79-2.26,1.01-3.46Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M41.87,154.13c11.2,36.96,45.52,63.87,86.13,63.87s74.94-26.91,86.13-63.87H41.87Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "107.68 116.39 133.81 90.26 186.06 142.52 186.06 162.84 107.68 162.84 107.68 116.39"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 126.7,
    y: 161.87,
    width: 62.15,
    height: 2.93
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "125.1 162.84 90.26 162.84 90.26 139.61 107.68 130.9 125.1 139.61 125.1 162.84"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.93,71.25c-.74,0-1.44,.15-2.12,.36-2.13-3.06-5.66-5.08-9.68-5.08s-7.55,2.01-9.68,5.08c-.67-.21-1.37-.36-2.12-.36-3.91,0-7.08,3.17-7.08,7.08h37.74c0-3.91-3.17-7.08-7.08-7.08Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.68,83.89c-.35,0-.69,.07-1,.17-1.01-1.45-2.69-2.41-4.59-2.41s-3.58,.96-4.59,2.41c-.32-.1-.65-.17-1-.17-1.85,0-3.36,1.5-3.36,3.36h17.9c0-1.85-1.5-3.36-3.36-3.36Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.75,52.55c-.35,0-.69,.07-1,.17-1.01-1.45-2.69-2.41-4.59-2.41s-3.58,.96-4.59,2.41c-.32-.1-.65-.17-1-.17-1.85,0-3.36,1.5-3.36,3.36h17.9c0-1.85-1.5-3.36-3.36-3.36Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M192.7,89.39c-.55,0-1.06,.11-1.56,.26-1.57-2.26-4.18-3.74-7.13-3.74s-5.56,1.48-7.13,3.74c-.5-.16-1.01-.26-1.56-.26-2.88,0-5.22,2.34-5.22,5.22h27.82c0-2.88-2.34-5.22-5.22-5.22Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.2,69.14c-.66,0-1.28,.13-1.88,.32-1.89-2.72-5.03-4.51-8.6-4.51s-6.71,1.79-8.6,4.51c-.6-.19-1.22-.32-1.88-.32-3.47,0-6.29,2.82-6.29,6.29h33.54c0-3.47-2.81-6.29-6.29-6.29Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "187.43 146.96 133.81 93.34 106.31 120.83 103.23 117.75 133.81 87.18 190.51 143.88 187.43 146.96"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "126.48 142.74 107.68 133.34 88.87 142.74 86.93 138.84 107.68 128.47 128.43 138.84 126.48 142.74"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.39,
    y: 119.29,
    width: 8.71,
    height: 11.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M125.82,131.63h-10.16v-13.06h10.16v13.06Zm-8.71-1.45h7.26v-10.16h-7.26v10.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 116.39,
    y: 121.47,
    width: 8.71,
    height: 1.45
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.9,
    y: 119.29,
    width: 8.71,
    height: 11.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M140.34,131.63h-10.16v-13.06h10.16v13.06Zm-8.71-1.45h7.26v-10.16h-7.26v10.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 130.9,
    y: 121.47,
    width: 8.71,
    height: 1.45
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 145.42,
    y: 119.29,
    width: 8.71,
    height: 11.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M154.85,131.63h-10.16v-13.06h10.16v13.06h0Zm-8.71-1.45h7.26v-10.16h-7.26v10.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 145.42,
    y: 121.47,
    width: 8.71,
    height: 1.45
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 136.71,
    y: 142.52,
    width: 8.71,
    height: 11.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M146.15,154.85h-10.16v-13.06h10.16v13.06h0Zm-8.71-1.45h7.26v-10.16h-7.26v10.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 136.71,
    y: 144.69,
    width: 8.71,
    height: 1.45
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 151.23,
    y: 142.52,
    width: 8.71,
    height: 11.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M160.66,154.85h-10.16v-13.06h10.16v13.06Zm-8.71-1.45h7.26v-10.16h-7.26v10.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 151.23,
    y: 144.69,
    width: 8.71,
    height: 1.45
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 165.74,
    y: 142.52,
    width: 8.71,
    height: 11.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M175.18,154.85h-10.16v-13.06h10.16v13.06h0Zm-8.71-1.45h7.26v-10.16h-7.26v10.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 165.74,
    y: 144.69,
    width: 8.71,
    height: 1.45
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.06,
    y: 142.52,
    width: 8.71,
    height: 11.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M105.5,154.85h-10.16v-13.06h10.16v13.06Zm-8.71-1.45h7.26v-10.16h-7.26v10.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 96.06,
    y: 144.69,
    width: 8.71,
    height: 1.45
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 110.58,
    y: 142.52,
    width: 8.71,
    height: 11.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M120.02,154.85h-10.16v-13.06h10.16v13.06Zm-8.71-1.45h7.26v-10.16h-7.26v10.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 110.58,
    y: 144.69,
    width: 8.71,
    height: 1.45
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M107.78,156.93c-1.12,0-2.18,.22-3.2,.54-3.22-4.63-8.56-7.68-14.63-7.68s-11.41,3.04-14.63,7.68c-1.02-.32-2.08-.54-3.2-.54-5.91,0-10.7,4.79-10.7,10.7h57.07c0-5.91-4.79-10.7-10.7-10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M100.91,156.93c-1.12,0-2.18,.22-3.2,.54-2.59-3.73-6.59-6.34-11.2-7.25-4.61,.91-8.61,3.52-11.2,7.25-1.02-.32-2.08-.54-3.2-.54-5.91,0-10.7,4.79-10.7,10.7h50.21c0-5.91-4.79-10.7-10.7-10.7Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M107.25,167.58c0-3.44,2.79-6.22,6.22-6.22,.52,0,1.01,.08,1.5,.2,1.62-1.75,3.93-2.87,6.5-2.87,4.91,0,8.89,3.98,8.89,8.89h-23.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M119.92,158.86c-1.94,.35-3.66,1.31-4.95,2.7-.48-.12-.98-.2-1.5-.2-3.44,0-6.22,2.79-6.22,6.22h19.9c0-4.34-3.12-7.95-7.23-8.72Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M128,218c32.39,0,60.74-17.14,76.58-42.82H51.42c15.85,25.68,44.19,42.82,76.58,42.82Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M188.21,194.77H67.79c15.94,14.41,37.02,23.23,60.21,23.23s44.27-8.82,60.21-23.23Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M61.72,152.27c-.35,0-.68,.07-.99,.17-1-1.43-2.65-2.38-4.53-2.38s-3.53,.94-4.53,2.38c-.31-.1-.64-.17-.99-.17-1.83,0-3.31,1.48-3.31,3.31h17.67c0-1.83-1.48-3.31-3.31-3.31Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M188.85,155.67c0-2.34,1.9-4.24,4.24-4.24,.35,0,.69,.06,1.02,.14,1.11-1.19,2.67-1.95,4.43-1.95,3.34,0,6.05,2.71,6.05,6.05h-15.74Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.21,79.46c0-4.07,3.3-7.38,7.38-7.38,.61,0,1.2,.1,1.77,.24,1.93-2.08,4.65-3.4,7.71-3.4,5.82,0,10.54,4.72,10.54,10.54h-27.4Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.75,70.22c0-2.5,2.03-4.54,4.54-4.54,.38,0,.74,.06,1.09,.15,1.18-1.28,2.86-2.09,4.74-2.09,3.58,0,6.48,2.9,6.48,6.48h-16.85Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 124.28,
    cy: 210.98,
    r: 2.42
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 151.71,
    cy: 203.97,
    r: 2.42
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 87.54,
    cy: 187.74,
    r: 1.67
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 105.7,
    cy: 181.77,
    r: 1.67
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 76.2,
    cy: 183.44,
    r: 1.67
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 114.94,
    cy: 186.06,
    r: 1.67
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 150.04,
    cy: 181.77,
    r: 1.67
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 183.84,
    cy: 183.44,
    r: 1.67
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 136.23,
    cy: 187.33,
    r: 1.67
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 171.77,
    cy: 187.33,
    r: 1.67
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 105.7,
    cy: 206.15,
    r: 2.42
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 132.78,
    cy: 202.94,
    r: 2.42
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLife);
export default __webpack_public_path__ + "static/media/social-life.a09b92f94b28d4735d6f5afcc177219f.svg";
export { ForwardRef as ReactComponent };